export default "__VITE_ASSET__BG0JDx9t__"